export default "__VITE_ASSET__WQkceMg___"